import * as qs from 'qs';
import type { ReactNode, Ref } from 'react';
import styled from 'styled-components';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import { AuthenticityToken } from '#src/components/form/AuthenticityToken/index.tsx';
import { API_ROOT } from '#src/config.ts';
import { useOAuthParams } from '#src/hooks/useOAuthParams.ts';
import { markTwaLeavingForOAuth } from '#src/lib/twaOAuthReturn.ts';

interface Props<T extends ReactNode | undefined = ReactNode> {
  provider: 'discord' | 'twitter' | 'google_oauth2' | 'facebook' | 'apple';
  sport?: Sport;
  children?: T;
  ref?: Ref<HTMLFormElement>;
}

const Form = styled.form`
  margin-bottom: 0;
`;

export const OAuthForm = (props: Props) => {
  const { provider, children, sport, ref } = props;

  const params = useOAuthParams({ sport });
  const querystring = qs.stringify(params, { skipNulls: true });

  return (
    <Form
      ref={ref}
      action={`${API_ROOT}/users/auth/${provider}?${querystring}`}
      method="post"
      onSubmit={markTwaLeavingForOAuth}
    >
      <AuthenticityToken />
      {children}
    </Form>
  );
};
